import type { PathwayQuestionnaireConfig } from '../configuration/shared';
import { useProgramContentOverride } from '../contexts/DrugProgramProvider';
import { useFillPrescription } from '../contexts/fill/use-fill-prescription';

import { useDrugKey } from './use-drug-key';

export const usePathwayQuestionnaire =
    (): PathwayQuestionnaireConfig | null => {
        const { medication } = useFillPrescription();
        const drugKey = useDrugKey(medication);
        const contentOverride = useProgramContentOverride();

        if (!drugKey) return null;
        return contentOverride.pathwayQuestionnaire?.[drugKey] ?? null;
    };
